// Queue priorities table (approved HTML component: queue-priorities).
import type { ReactNode } from 'react';
import type { QueueRow } from '../mockData.js';

export interface QueuePrioritiesProps {
  rows: QueueRow[];
}

export function QueuePriorities({ rows }: QueuePrioritiesProps): ReactNode {
  return (
    <section className="n-card" data-component="queue-priorities">
      <div className="n-head">
        <h2>Queue priorities</h2>
        <small />
      </div>
      <table className="n-table">
        <thead>
          <tr>
            <th>Work type</th>
            <th>Waiting</th>
            <th>Oldest item</th>
            <th>System handling</th>
          </tr>
        </thead>
        <tbody>
          {rows.map(row => (
            <tr key={row.workType}>
              <td>{row.workType}</td>
              <td>{row.waiting}</td>
              <td>{row.oldest}</td>
              <td>
                <span className={`n-pill${row.tone && row.tone !== 'default' ? ' ' + row.tone : ''}`}>
                  {row.handling}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="n-body">
        <p>
          Service requests route to Customer Service. This queue shows Sales work only. Priority rules
          are supplied by the runtime.
        </p>
      </div>
    </section>
  );
}
